import { notNil } from '@sixfold/typed-primitives';

import { Company, CompanyPermissions, UserProfile } from '../entities';

export const isCarrier: (company: Company) => boolean = (company) => !company.is_shipper && company.is_carrier;
export const isShipper: (company: Company) => boolean = (company) => company.is_shipper;

export const getCompanyPermissions: (company: {
  is_shipper: boolean | null;
  is_carrier: boolean | null;
  is_test: boolean | null;
  arePlacesEnabled: boolean | null;
  isVisibilityControlCenterDisabled: boolean;
  isInvitationFlowDisabled: boolean;
  isMapVehicleLocationsEnabled: boolean;
  isGlobalAllocationEnabled: boolean;
  isAutoAllocationEnabled: boolean;
  isAutoAllocationFullVisibilityEnabled: boolean;
  isOceanMapViewEnabled: boolean;
  isEmailLoginEnabled: boolean;
  isAnalyticsEnabled: boolean;
  isRoadUiDisabled: boolean;
  isFilesUploadEnabled: boolean;
  isStandalonePagesEnabled: boolean;
  isOceanUIEnabled: boolean;
  isAirUIEnabled: boolean;
  isInlandVisibilityEnabled: boolean;
  isOceanAnalyticsEnabled: boolean;
  isTableExportConfigEnabled: boolean;
  isMaritimeIntelligenceEnabled: boolean;
  isOceanTransportExcelUploadEnabled: boolean;
}) => CompanyPermissions = (company) => {
  const isCarrier = company.is_carrier === true;
  const isShipper = company.is_shipper === true;
  const placesEnabled = company.arePlacesEnabled === true;
  const invitationFlowEnabled = company.isInvitationFlowDisabled === false;
  const standalonePagesEnabled = isShipper && company.isStandalonePagesEnabled;

  return {
    shouldSeeIntegrations: isCarrier,
    shouldSeeVehicles: isCarrier,
    shouldSeePlaces: placesEnabled,
    shouldSeeFleetMonitor: isCarrier,
    shouldSeeInvitationFlow: invitationFlowEnabled,
    shouldSeeMapVehicleLocations: company.isMapVehicleLocationsEnabled,
    shouldNotSeeVisibilityControlCenter: company.isVisibilityControlCenterDisabled,
    shouldNotSeeRoadUI: company.isRoadUiDisabled,
    isGlobalAllocationEnabled: company.isGlobalAllocationEnabled,
    isAutoAllocationEnabled: company.isAutoAllocationEnabled,
    isAutoAllocationFullVisibilityEnabled: company.isAutoAllocationFullVisibilityEnabled,
    shouldSeeOceanMapView: company.isOceanMapViewEnabled,
    hasUserManagementEnabled: company.isEmailLoginEnabled,
    shouldSeeAnalytics: company.isAnalyticsEnabled,
    shouldSeeOceanAnalytics: company.isOceanAnalyticsEnabled,
    shouldSeeOceanUI: company.isOceanUIEnabled || standalonePagesEnabled,
    shouldSeeAirUI: company.isAirUIEnabled || standalonePagesEnabled,
    shouldSeeInlandUI: company.isInlandVisibilityEnabled,
    shouldSeeStandalonePages: standalonePagesEnabled,
    shouldSeeTableExportConfig: company.isTableExportConfigEnabled,
    shouldSeeMaritimeIntelligence: true,
    shouldSeeOceanTransportExcelUpload: company.isOceanTransportExcelUploadEnabled,
  };
};

export function getUserName(profile: UserProfile) {
  const { first_name, last_name, email } = profile;
  return [first_name, last_name].filter(notNil).join(' ') || email;
}
